module.exports = __webpack_public_path__ + "img/46_28.6709c081.png";